<!--<div *ngIf="aztecScannedCompletedActionInfoVisible"-->
<!--     class="vehicle-model-section__completed-action-info vehicle-model-section__completed-action-info&#45;&#45;aztec">-->
<!--    <app-completed-action-info [leftContent]="aztecScannedCompletedActionInfoLeftContent"-->
<!--                               (buttonClick)="aztecScannerService.scan()"-->
<!--                               [data]="aztecScannedCompletedActionInfoData">-->
<!--    </app-completed-action-info>-->
<!--</div>-->

<app-section #parentSection
             [title]="title"
             *ngIf="sectionVisible"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [key]="key"
             [class]="sectionClass"
             [ngClass]="{'vehicle-model-section--sections-below': sectionsBellow}"
             [formConfig]="formConfig"
             [editMode]="true">

    <ng-template #section>

            <app-section-data-presentation *ngIf="previewMode"
                                           [parentSection]="parentSection"
                                           [formGroup]="formGroup"
                                           [formConfig]="formConfig"
                                           (afterViewInit)="onSectionDataPresentationAfterViewInit()"
                                            (editModeChange)="onEditModeChange()">
            </app-section-data-presentation>

            <div *ngIf="clearDataVisible" class="clear-data">
                {{ 'VEHICLE_MODEL_SECTION.CLEAR_DATA.text' | translate }}
                <a class="clear-data__btn" (click)="clearVehicleCalculationData()">{{ 'VEHICLE_MODEL_SECTION.CLEAR_DATA.action' | translate }}</a>
            </div>

            <div class="vehicle-model-section__fields">
<!--                <div class="col registration-number" [ngClass]="{'col-preview-mode': previewMode}">-->
<!--                    <div *ngIf="canFieldDisplayed(consts.REGISTRATION_NUMBER)" class="section__component col-50">-->
<!--                        <app-text-field [bean]="bean"-->
<!--                                        [errorsMap]="formFactoryService.errorsMap"-->
<!--                                        [control]="formGroup.controls[consts.REGISTRATION_NUMBER]"-->
<!--                                        [fieldConfig]="formFactoryService.fieldConfig(consts.REGISTRATION_NUMBER, formConfig)"-->
<!--                                        [context]="formConfig.formKey"-->
<!--                                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.REGISTRATION_NUMBER)]"-->
<!--                                        (markAsDirty)="markAsDirty($event)"-->
<!--                                        (changeEvent)="registrationNumberChangeEvent($event)"-->
<!--                                        (click)="registrationNumberClick()"-->
<!--                        >-->
<!--                        </app-text-field>-->
<!--                    </div>-->
<!--                    <div *ngIf="unknownRegistrationNumberVisible"-->
<!--                         class="section__component col-50 registration-number__unknown-number">-->
<!--                        <app-checkbox [control]="formGroup.controls[consts.UNKNOWN_REGISTRATION_NUMBER]"-->
<!--                                      [bean]="bean"-->
<!--                                      [fieldConfig]="getFieldConfig(consts.UNKNOWN_REGISTRATION_NUMBER)"-->
<!--                                      [errorsMap]="formFactoryService.errorsMap">-->
<!--                        </app-checkbox>-->
<!--                        <app-hint-->
<!--                                *ngIf="unknownRegistrationNumber"-->
<!--                                class="registration-number__unknown-number__hint"-->
<!--                                [content]="'VEHICLE_MODEL_SECTION.unknownRegistrationNumberHint'"-->
<!--                                [arrowUp]="true">-->

<!--                        </app-hint>-->
<!--                    </div>-->
<!--                </div>-->

                <div    *ngIf="vehicleModelStateService.chipsVisible && !this.previewMode"
                        class="vehicle-model-section__chips"
                        [ngClass]="{'col-50': unknownRegistrationNumber}">
                    <app-chips-list [config]="vehicleModelStateService.chipsListConfig"
                                    [chipsValues]="vehicleModelStateService.chipsValues"
                                    (chipRemoval)="onChipRemoval($event)">
                    </app-chips-list>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.BRAND_CODE)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.BRAND_CODE)" class="section__component col-50">
                        <app-select [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.BRAND_CODE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.BRAND_CODE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.BRAND_CODE)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.PRODUCTION_YEAR)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.PRODUCTION_YEAR)" class="section__component col-50 vehicle-model-section__production-year">
                        <app-material-year-picker *ngIf="productionYearAsDatepicker"
                                                 #productionYearField
                                                 [bean]="bean"
                                                 [errorsMap]="formFactoryService.errorsMap"
                                                 [control]="formGroup.controls[consts.PRODUCTION_YEAR]"
                                                 [fieldConfig]="formFactoryService.fieldConfig(consts.PRODUCTION_YEAR, formConfig)"
                                                 [context]="formConfig.formKey"
                                                 [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PRODUCTION_YEAR)]"
                                                 (markAsDirty)="markAsDirty($event)"
                                                 (opened)="onFieldOpened()"></app-material-year-picker>

                        <app-select *ngIf="!productionYearAsDatepicker"
                                                 [bean]="bean"
                                                 [errorsMap]="formFactoryService.errorsMap"
                                                 [control]="formGroup.controls[consts.PRODUCTION_YEAR]"
                                                 [fieldConfig]="formFactoryService.fieldConfig(consts.PRODUCTION_YEAR, formConfig)"
                                                 [context]="formConfig.formKey"
                                                 [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PRODUCTION_YEAR)]"
                                                 [selectDialogRef]="selectDialogRef"
                                                 (markAsDirty)="markAsDirty($event)"
                                                 (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                                                 (opened)="onFieldOpened()"></app-select>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.MODEL_CODE)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.MODEL_CODE)" class="section__component col-50 vehicle-model-section__select-with-custom-template">
                        <app-select [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.MODEL_CODE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.MODEL_CODE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.MODEL_CODE)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.FUEL_CODE)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.FUEL_CODE)" class="section__component col-50">
                        <app-select [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.FUEL_CODE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.FUEL_CODE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.FUEL_CODE)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.ENGINE_CAPACITY)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.ENGINE_CAPACITY)" class="section__component col-50">
                        <app-select [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.ENGINE_CAPACITY]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.ENGINE_CAPACITY, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ENGINE_CAPACITY)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"

                        >
                        </app-select>
                    </div>
                    <div *ngIf="resolveElementVisibility(mainContentConfig.collectedCarsAmount)" class="models-found__wrapper col-50">
                        <app-collected-car></app-collected-car>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.ENGINE_POWER)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.ENGINE_POWER)" class="section__component col-50">
                        <app-select [bean]="bean"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.ENGINE_POWER]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.ENGINE_POWER, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ENGINE_POWER)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isFieldActive(consts.VEHICLE_CODE_EUROTAX)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.VEHICLE_CODE_EUROTAX)" class="section__component col-50 vehicle-model-section__select-with-custom-template">
                        <app-select [bean]="bean"
                                    class="custom-select-with-two-lines"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.VEHICLE_CODE_EUROTAX]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.VEHICLE_CODE_EUROTAX, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VEHICLE_CODE_EUROTAX)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="infoexpertFieldVisible && vehicleModelStateService.isFieldActive(consts.VEHICLE_CODE_INFOEKSPERT)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.VEHICLE_CODE_INFOEKSPERT)" class="section__component col-50 vehicle-model-section__select-with-custom-template">
                        <app-select [bean]="bean"
                                    class="custom-select-with-two-lines"
                                    [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.VEHICLE_CODE_INFOEKSPERT]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.VEHICLE_CODE_INFOEKSPERT, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VEHICLE_CODE_INFOEKSPERT)]"
                                    [selectDialogRef]="selectDialogRef"
                                    (markAsDirty)="markAsDirty($event)"
                                    (opened)="onFieldOpened()"
                                    (selectDialogRefUpdate)="updateSelectDialogRef($event)"
                        >
                        </app-select>
                    </div>
                </div>

                <div *ngIf="!vehicleModelStateService.isDiagnosticStationContext" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.START_INSURANCE_DATE)"
                         class="section__component col-50 datepicker-component vehicle-model-section__insurance-date">
                        <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                                 [control]="formGroup.controls[consts.START_INSURANCE_DATE]"
                                                 [fieldConfig]="formFactoryService.fieldConfig(consts.START_INSURANCE_DATE, formConfig)"
                                                 [context]="formConfig.formKey"
                                                 [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.START_INSURANCE_DATE)]"
                                                 (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
                    </div>
                </div>

                <div *ngIf="vehicleModelStateService.isDiagnosticStationContext" class="col" [ngClass]="{'col-preview-mode': previewMode}">
                    <div *ngIf="canFieldDisplayed(consts.END_INSURANCE_DATE)"
                         class="section__component col-50 datepicker-component vehicle-model-section__insurance-date">
                        <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                                 [control]="formGroup.controls[consts.END_INSURANCE_DATE]"
                                                 [fieldConfig]="formFactoryService.fieldConfig(consts.END_INSURANCE_DATE, formConfig)"
                                                 [context]="formConfig.formKey"
                                                 [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.END_INSURANCE_DATE)]"
                                                 (markAsDirty)="markAsDirty($event)"></app-material-datepicker>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="link4DebugMode">
                <div *ngIf="infoExpertLink4Dictionary && infoExpertLink4Dictionary.length; else noItems">
                    <ol>
                        <li *ngFor="let item of infoExpertLink4Dictionary">
                            [{{item.code}}] {{item.name}} - {{item.bodyType}} - {{item.engineCapacity}}cm3 - {{item.horsepower}}KM - {{item.kilowatts}}kW - {{item.numberOfDoors}} drz. - {{item.kind}}
                        </li>
                    </ol>
                </div>
                <ng-template #noItems>
                    <span>Słownik InfoExpert Link4 jest pusty.</span>
                </ng-template>
            </ng-container>

<!--            <div *ngIf="footerVisible"-->
<!--                 class="vehicle-model-section__footer">-->
<!--                <div [innerHTML]="'VEHICLE_MODEL_SECTION.footer' | translate | safeHtml"></div>-->
<!--            </div>-->

    </ng-template>
</app-section>

<!--<div *ngIf="aztecScannerInfoVisible"-->
<!--     [ngClass]="{-->
<!--        'vehicle-model-section__aztec-scanner-info&#45;&#45;scanned': aztecScannedFromQrCode,-->
<!--        'vehicle-model-section__aztec-scanner-info&#45;&#45;diagnostic-station': diagnosticStationScanView-->
<!--    }"-->
<!--     class="vehicle-model-section__aztec-scanner-info">-->
<!--    <app-aztec-scanner-info [sectionsBellow]="sectionsBellow"-->
<!--                            (openAztecScanner)="aztecScannerService.openAztecScanner()">-->
<!--    </app-aztec-scanner-info>-->
<!--</div>-->

<!--<div *ngIf="appStateService.aztecScannerActive"-->
<!--     class="vehicle-model-section__aztec-scanner">-->
<!--    <app-next-aztec-scanner (close)="closeAztecScanner($event)">-->
<!--    </app-next-aztec-scanner>-->
<!--</div>-->

<!--<div *ngIf="diagnosticStationProcessInfoVisible"-->
<!--     class="vehicle-model-section__diagnostic-station-process-info">-->
<!--    <app-aztec-process-info></app-aztec-process-info>-->

<!--    <app-next-other-products [title]="'AZTEC_PROCESS_INFO.productsTitle'"-->
<!--                             [theme]="OtherProductsTheme.WHITE">-->
<!--    </app-next-other-products>-->
<!--</div>-->

<!--<div *ngIf="vehicleModelStateService.scanClientAgreementButtonVisible"-->
<!--     class="vehicle-model-section__scan-customer-agreement-btn">-->
<!--    <button class="btn btn&#45;&#45;secondary btn&#45;&#45;big"-->
<!--            (click)="scanCustomerAgreement()">-->
<!--        {{ 'VEHICLE_MODEL_SECTION.scanCustomerAgreement' | translate }}-->
<!--    </button>-->
<!--</div>-->

<!--<div *ngIf="customerAgreementScanningMode"-->
<!--     class="vehicle-model-section__customer-agreement-capture">-->
<!--    <app-customer-agreement-capture (result)="onCustomerAgreementCaptureResult($event)"></app-customer-agreement-capture>-->
<!--</div>-->

<!--<div *ngIf="vehicleModelStateService.customerAgreementPhotoCompletedActionInfoVisible"-->
<!--     class="vehicle-model-section__completed-action-info vehicle-model-section__completed-action-info&#45;&#45;photo">-->
<!--    <app-completed-action-info [leftContent]="customerAgreementPhotoCompletedActionInfoLeftContent"-->
<!--                               (buttonClick)="scanCustomerAgreement()"-->
<!--                               [data]="customerAgreementPhotoCompletedActionInfoData">-->
<!--    </app-completed-action-info>-->
<!--</div>-->

<!--<ng-template #aztecScannedCompletedActionInfoLeftContent>-->
<!--    <div class="vehicle-model-section__completed-action-info__icon">-->
<!--        <span class="material-icons">check</span>-->
<!--    </div>-->
<!--</ng-template>-->

<!--<ng-template #customerAgreementPhotoCompletedActionInfoLeftContent>-->
<!--    <div class="vehicle-model-section__completed-action-info__photo"-->
<!--        (click)="vehicleModelStateService.openCustomerAgreementPhotoPreview()">-->
<!--        <img [src]="vehicleModelStateService.customerAgreementPhoto" alt="">-->
<!--    </div>-->
<!--</ng-template>-->

